var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.gradeInfoList),function(info,index){return _c('span',{key:index,staticClass:"img-box"},[_c('img',{attrs:{"src":require(`@/assets/images/common/element-icons-72-x-72-ic-rating-content-${info.title}.svg`),"width":_vm.size,"height":_vm.size,"alt":"주제 아이콘"}}),_c('em',{staticClass:"text"},[_vm._v(_vm._s(info.grade))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }